var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-category-view-manager',{attrs:{"id":"manager","show-search-bar":"","orange-theme":"","create-route-path":"create","edit-route-name":_vm.categoryEditRoute,"details-route-name":_vm.categoryDetailsRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }